<div class="invoice-header-container mb-20 mct-flex mct-row mct-justify-between mct-items-center"  >
  <div *ngIf="profileId > 0 && profile" style="font-size: 18px">
    <wl-profile-type-icon [isMember]="profile.Member" [isOrg]="profile.OrgInd" [profileId]="profile.ProfileId"
      [styleOverrides]="{ 'max-width': '34px', 'max-height': '34px' }" class="mr-11"></wl-profile-type-icon>
    <strong>{{ profile.ReportName }}</strong>&nbsp;
    <span style="color: #999">({{ profile.ProfileId }})</span>&nbsp;
    <a (click)="changeProfileClick()" style="font-size: 14px;">{{ 'invoices.invoice-edit.change-profile' | translate
      }}</a>
  </div>
  <div class="mct-flex mct-row mct-justify-center mct-items-center"  >
    <a class="mr-20" [hidden]="!invoiceNum" (click)="viewOrPrint()">
      <strong>{{ 'invoices.invoice-builder.view-print' | translate | uppercase }}</strong>
    </a>
    <button pButton type="button" class="btn btn-danger mr-5" type="button" title="{{ 'common.cancel' | translate | titlecase }}"
      (click)="cancelClick()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="btn btn-primary" type="button" (click)="saveClick()"
      title="{{ 'common.save' | translate | titlecase }}" [disabled]="!saveAccess || isSaving">
      <wl-busy [show]="isSaving || isLoading"></wl-busy>
      <span *ngIf="isLoading"> {{ 'common.loading' | translate | uppercase }}</span>
      <span *ngIf="!isLoading && isSaving"> {{ 'common.saving' | translate | uppercase }}</span>
      <span *ngIf="!isLoading && !isSaving">{{ 'common.save' | translate | uppercase }}</span>
    </button>
  </div>
</div>
<wl-invoice-builder [isNewMemberInvoice]="false" [invoice]="invoice" [creditCardPayment]="creditCardPayment"
  [profileId]="profileId" [paymentTypeInvalid]="paymentTypeInvalid" (paymentTypeSelected)="paymentTypeInvalid = false">
</wl-invoice-builder>
<p-dialog #refundFailedAlert modal="true" [(visible)]="showRefundFailedAlert" [closable]="false" styleClass="atlas-dialog-s" [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }">
  {{ 'invoices.invoice-builder.refund-failed' | translate }}
  <ng-template pTemplate="footer">
    <button pButton type="button" class="btn btn-primary" type="button" (click)="showRefundFailedAlert = false">
      {{ 'common.ok' | translate | titlecase }}
    </button>
  </ng-template>
</p-dialog>

<wl-invoice-modification [(showPrompt)]="showModificationPrompt" [itemName]="modificationItemName" [invoice]="invoice"
  (invoiceModified)="invoiceModified()"></wl-invoice-modification>

<p-dialog modal="true" [(visible)]="showNoPaymentAdjustmentAlert" [closable]="false" styleClass="atlas-dialog-m">
  <ng-template pTemplate="header">
    <h3>{{ 'invoices.invoice-builder.imbalance-header' | translate | titlecase }}</h3>
  </ng-template>
  {{ 'invoices.invoice-builder.no-payment-adjustment-message' | translate }}
  <ng-template pTemplate="footer">
    <div class="mct-flex-gt-md mct-row-gt-md mct-flex-lt-md mct-col-lt-md mct-justify-end mct-items-center mct-gap-10"    >
      <button pButton type="button" class="atlas-btn atlas-btn-secondary" type="button" (click)="showNoPaymentAdjustmentAlert = false">
        {{ 'invoices.invoice-builder.cancel-and-add-payment-adjustment' | translate | uppercase }}
      </button>
      <button pButton type="button" class="atlas-btn atlas-btn-primary" type="button"
        (click)="showNoPaymentAdjustmentAlert = false; saveInvoice()">
        {{ 'invoices.invoice-builder.save-line-item-adjustment-only' | translate | uppercase }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog modal="true" [(visible)]="showNoLineItemAdjustmentAlert" [closable]="false" styleClass="atlas-dialog-m">
  <ng-template pTemplate="header">
    <h3>{{ 'invoices.invoice-builder.imbalance-header' | translate | titlecase }}</h3>
  </ng-template>
  {{ 'invoices.invoice-builder.no-line-adjustment-message' | translate }}
  <ng-template pTemplate="footer">
    <div class="mct-flex-gt-md mct-row-gt-md mct-flex-lt-md mct-col-lt-md mct-justify-end mct-items-center mct-gap-10"    >
      <button pButton type="button" class="atlas-btn atlas-btn-secondary" type="button" (click)="showNoLineItemAdjustmentAlert = false">
        {{ 'invoices.invoice-builder.cancel-and-add-line-adjustment' | translate | uppercase }}
      </button>
      <button pButton type="button" class="atlas-btn atlas-btn-primary" type="button"
        (click)="showNoLineItemAdjustmentAlert = false; saveInvoice()">
        {{ 'invoices.invoice-builder.save-payment-adjustment-only' | translate | uppercase }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-confirmDialog #refundConfirmation header="{{ 'invoices.invoice-edit.refund-confirmation.title' | translate }}" [closable]="false" styleClass="atlas-dialog-m">
  <ng-template pTemplate="footer">
    <div class="mct-flex-gt-md mct-row-gt-md mct-flex-lt-md mct-col-lt-md mct-justify-end mct-items-center mct-gap-10"    >
      <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="confirmAccept(true)">
        {{ 'invoices.invoice-edit.refund-confirmation.yes' | translate | uppercase }}
      </button>
      <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="confirmAccept(false)">
        {{ 'invoices.invoice-edit.refund-confirmation.no' | translate | uppercase }}
      </button>
      <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="refundConfirmation.reject()">
        {{ 'invoices.invoice-edit.refund-confirmation.cancel' | translate | uppercase }}
      </button>
    </div>
  </ng-template>
</p-confirmDialog>

<p-dialog #changeUser modal="true" [closable]="false" styleClass="atlas-dialog-m" [(visible)]="showChangeProfile" [contentStyle]="{ 'max-height': '75vh' }" position="top">
  <ng-template pTemplate="header">
    {{ 'invoices.invoice-edit.select-profile' | translate | titlecase }}
  </ng-template>
  <wl-profile-search-and-select (profileSelected)="changeProfile($event.ProfileId)"></wl-profile-search-and-select>
  <ng-template pTemplate="footer">
    <div class="mct-flex mct-row mct-justify-end mct-items-stretch"  >
      <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="cancelChangeProfile()">{{ 'common.cancel' | translate |
        uppercase }}</button>
    </div>
  </ng-template>
</p-dialog>
